import 'css-chunksrc/client/pages/workloadPage/table/styles.scss';export default {
  "tableWrapper": "_tableWrapper_wxfdh_1",
  "table": "_table_wxfdh_1",
  "monthRow": "_monthRow_wxfdh_12",
  "monthCornerCell": "_monthCornerCell_wxfdh_20",
  "monthCell": "_monthCell_wxfdh_32",
  "headerRow": "_headerRow_wxfdh_48",
  "withMonthRow": "_withMonthRow_wxfdh_56",
  "resourceHeaderCell": "_resourceHeaderCell_wxfdh_60",
  "headerCell": "_headerCell_wxfdh_80"
};